import { axios } from '@/utils/axios'

export async function fetchNews (data) {
  return axios({
    method: 'post',
    url: '/api/bff/cms/news',
    data
  })
}
